import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeading from './SectionHeading';
import { getLocaleList } from '../utils/localeList';
import useReveal from '../hooks/useReveal';

/**
 * Section 03 — Explore / Fund / Build / Integrate.
 *
 * Each stage is framed by the client's situation ("you don't know what to build
 * yet") rather than by the technology, which is the whole point of the section:
 * we sell outcomes, not stacks. The service list under each stage stays
 * secondary on purpose.
 */
const WhatWeDo = () => {
  const { t } = useTranslation();
  const reveal = useReveal();
  const stages = getLocaleList(t, 'whatWeDo.stages');

  return (
    <div id="what-we-do" className="mainCont relative z-30 pt-5 mt-[100px] lg4:mt-[150px]" ref={reveal} data-reveal>
      <SectionHeading
        eyebrow={t('whatWeDo.eyebrow')}
        title={t('whatWeDo.title')}
        intro={t('whatWeDo.intro')}
        image="/images/tokenization-paltalabs.png"
      />

      <div className="grid grid-cols-1 sm3:grid-cols-2 lg:grid-cols-4 gap-6">
        {stages.map((stage) => (
          <div
            key={stage.name}
            className="landingCard p-6 flex flex-col"
          >
            <div className="font-grotesk text-[22px] font-bold text-main uppercase">{stage.name}</div>
            <p className="text-white text-sm mt-3">{stage.when}</p>
            <ul className="mt-5 space-y-2 border-t border-white/10 pt-4">
              {stage.services.map((service) => (
                <li key={service} className="flex items-start text-sm text-main-gray">
                  <span className="text-main mr-2">✓</span>
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeDo;
